import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function StudentSettingNav(props){
    const { t } = useTranslation();
    return (
        <>
        <ul className="settings-pg-links list-unstyled">
                        <li><Link to={`/home/settings/profile`} className={`${props.active_menu=='profile'?'active':''}`}>
                            <i className="fa-light fa-edit" />{t('studentSettingNav.edit_profile')}</Link>
                        </li>

                        <li><Link to={`/home/settings/change-password`} className={`${props.active_menu=='password'?'active':''}`}><i className="fa-light fa-lock" />{t('studentSettingNav.change_password')}</Link></li>
                        <li><a href="#"><i className="fa-light fa-bell" />{t('studentSettingNav.notifications')}</a></li>
                    </ul>
        </>
    )
}